var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.tableStatus.mode !== "copy"
        ? _c("f-table", {
            ref: "fTable",
            attrs: {
              loading: _vm.loading,
              downloading: _vm.downloading,
              tableStatus: _vm.tableStatus,
              data: _vm.data,
              statusList: _vm.statusList,
              topicList: _vm.topicList,
              kpmgOwnerList: _vm.kpmgOwnerList,
              clientOwnerList: _vm.clientOwnerList,
              pagination: _vm.pagination,
              onCancel: _vm.onCancel,
              onChange: _vm.onChange,
              onPaginationChange: _vm.onPaginationChange,
              onChangeStatusPopShow: _vm.onChangeStatusPopShow,
              onUploadFileAfter: _vm.onUploadFileAfter,
              sourceTypes: _vm.sourceTypes,
              onChangeRow: _vm.onChangeRow,
              onDownLoad: _vm.onDownLoad,
              downloadAble: _vm.downloadAble,
              curUserName: _vm.curUserName,
              siteId: _vm.siteId,
              showColumns: _vm.showColumns,
              serialNo: _vm.serialNoHere,
              topic: _vm.topicHere,
              topicDesList: _vm.topicDesList,
              topicDes: _vm.topicDesHere,
              createDate: _vm.createDateHere,
              dueTime: _vm.dueTimeHere,
              sourceOfInfo: _vm.sourceOfInfoHere,
              filterStatusList: _vm.filterStatusList,
              status: _vm.statusHere,
              dayOverDue: _vm.dayOverDueHere,
              daysUntilDue: _vm.daysUntilDueHere,
              uploadTime: _vm.uploadTimeHere,
              periodEndDate: _vm.periodEndDateHere,
              commentDate: _vm.commentDateHere,
              fileName: _vm.fileNameHere,
              clientResponsible: _vm.clientResponsibleHere,
              kpmgResponsible: _vm.kpmgResponsibleHere,
              updateGuide: _vm.updateGuide,
              updateGuideStep: _vm.updateGuideStep,
              lastedUploadUserAccount: _vm.lastedUploadUserAccountHere,
              screenWidth: _vm.screenWidth,
              clientConfirmDate: _vm.clientConfirmDateHere,
              messageType: _vm.messageType,
            },
            on: {
              selectKPOwner: _vm.selectKPOwner,
              selectClientOwner: _vm.selectClientOwner,
              "on-dueday-change": _vm.onDuedayChange,
              "on-charge-user-change": _vm.onChargeUserChange,
              "on-confirm-day-change": _vm.onConfirmDayChange,
              "update:serialNo": function ($event) {
                _vm.serialNoHere = $event
              },
              "update:serial-no": function ($event) {
                _vm.serialNoHere = $event
              },
              "update:topic": function ($event) {
                _vm.topicHere = $event
              },
              "update:topicDes": function ($event) {
                _vm.topicDesHere = $event
              },
              "update:topic-des": function ($event) {
                _vm.topicDesHere = $event
              },
              "update:createDate": function ($event) {
                _vm.createDateHere = $event
              },
              "update:create-date": function ($event) {
                _vm.createDateHere = $event
              },
              "update:dueTime": function ($event) {
                _vm.dueTimeHere = $event
              },
              "update:due-time": function ($event) {
                _vm.dueTimeHere = $event
              },
              "update:sourceOfInfo": function ($event) {
                _vm.sourceOfInfoHere = $event
              },
              "update:source-of-info": function ($event) {
                _vm.sourceOfInfoHere = $event
              },
              "update:status": function ($event) {
                _vm.statusHere = $event
              },
              "update:dayOverDue": function ($event) {
                _vm.dayOverDueHere = $event
              },
              "update:day-over-due": function ($event) {
                _vm.dayOverDueHere = $event
              },
              "update:daysUntilDue": function ($event) {
                _vm.daysUntilDueHere = $event
              },
              "update:days-until-due": function ($event) {
                _vm.daysUntilDueHere = $event
              },
              "update:uploadTime": function ($event) {
                _vm.uploadTimeHere = $event
              },
              "update:upload-time": function ($event) {
                _vm.uploadTimeHere = $event
              },
              "update:periodEndDate": function ($event) {
                _vm.periodEndDateHere = $event
              },
              "update:period-end-date": function ($event) {
                _vm.periodEndDateHere = $event
              },
              "update:commentDate": function ($event) {
                _vm.commentDateHere = $event
              },
              "update:comment-date": function ($event) {
                _vm.commentDateHere = $event
              },
              "update:fileName": function ($event) {
                _vm.fileNameHere = $event
              },
              "update:file-name": function ($event) {
                _vm.fileNameHere = $event
              },
              "update:clientResponsible": function ($event) {
                _vm.clientResponsibleHere = $event
              },
              "update:client-responsible": function ($event) {
                _vm.clientResponsibleHere = $event
              },
              "update:kpmgResponsible": function ($event) {
                _vm.kpmgResponsibleHere = $event
              },
              "update:kpmg-responsible": function ($event) {
                _vm.kpmgResponsibleHere = $event
              },
              nextClick: _vm.nextClick,
              "update:lastedUploadUserAccount": function ($event) {
                _vm.lastedUploadUserAccountHere = $event
              },
              "update:lasted-upload-user-account": function ($event) {
                _vm.lastedUploadUserAccountHere = $event
              },
              "update:clientConfirmDate": function ($event) {
                _vm.clientConfirmDateHere = $event
              },
              "update:client-confirm-date": function ($event) {
                _vm.clientConfirmDateHere = $event
              },
            },
          })
        : _c("m-table", {
            attrs: {
              data: _vm.dataPBC,
              tableStatus: _vm.tableStatus,
              onCancel: _vm.onCancelInterim,
              onCopy: _vm.onCopy,
              loading: _vm.loading,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }